'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _EN = require('./EN');

var _EN2 = _interopRequireDefault(_EN);

var _RU = require('./RU');

var _RU2 = _interopRequireDefault(_RU);

var _UA = require('./UA');

var _UA2 = _interopRequireDefault(_UA);

var _TR = require('./TR');

var _TR2 = _interopRequireDefault(_TR);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var disputes = {
    ru: _RU2.default,
    ua: _UA2.default,
    en: _EN2.default,
    tr: _TR2.default
};

exports.default = disputes;